import actions from "./actions";
import crudReducers from "../../crud/reducers";
import {
  initialDataState,
  reduceDataError,
  reduceDataRequest,
  reduceDataSuccess,
} from "../../../reducersHelper";

const crud = crudReducers(actions);

const initState = {
  overview: {},
  list: [],
  listContext: null,
  page: 1,
  pageSize: 20,
  total: 0,
  listError: null,
  listLoaded: false,
  loading: false,
  loaded: false,
  error: false,
  modalActive: false,
  filterModalActive: false,
  replyModalActive: false,
  repliesActive: {},
  filters: {
    type: "",
    includePrivate: "true",
  },
  allNotes: {
    data: [],
    loading: false,
    loaded: false,
    error: false,
  },
  alerts: {
    data: [],
    loading: false,
    loaded: false,
    error: false,
  },
  data: {
    messageType: "",
  },
  downloadCSV: initialDataState,
};
const reducers = (state = initState, action) => {
  let repliesActive;
  switch (action.type) {
    case actions.GET_OVERVIEW_PAGE_REQUEST: {
      const request = action.payload;
      return {
        ...state,
        overview: {
          ...state.overview,
          [request.kind]: { request, data: [], total: 0, loading: true, error: null },
        },
      };
    }
    case actions.CLOSE_OVERVIEW_PAGE:
    case actions.GET_OVERVIEW_PAGE_SUCCESS:
    case actions.GET_OVERVIEW_PAGE_ERROR: {
      const { request } = action;
      const current = state.overview[request.kind];
      if (!current || current.request !== request) return state;
      return {
        ...state,
        overview: {
          ...state.overview,
          [request.kind]: action.type === actions.CLOSE_OVERVIEW_PAGE ? null : {
            ...current,
            loading: false,
            data: action.type === actions.GET_OVERVIEW_PAGE_SUCCESS ? action.payload.messages : [],
            total: action.type === actions.GET_OVERVIEW_PAGE_SUCCESS ? action.payload.total : 0,
            error: action.error || null,
          },
        },
      };
    }
    case actions.CLEAR:
      return { ...initState, allNotes: state.allNotes, alerts: state.alerts };
    case actions.OPEN_LIST:
      return {
        ...state, listContext: action.payload, page: 1, pageSize: 20,
        list: [], total: 0, listLoaded: false, loading: true, listError: null,
      };
    case actions.CLOSE_LIST:
      return {
        ...state, listContext: null, list: [], total: 0, page: 1,
        listLoaded: false, loading: false, listError: null,
      };
    case actions.GET_LIST_REQUEST:
      if (!state.listContext) return state;
      return {
        ...state,
        page: action.payload.providerId === state.listContext.providerId &&
          action.payload.userId === state.listContext.userId
          ? (action.payload.page || state.page) : state.page,
        loading: true, listLoaded: false, listError: null,
      };
    case actions.GET_LIST_SUCCESS:
    case actions.GET_LIST_ERROR: {
      const query = action.requestPayload;
      if (!query || query.context !== state.listContext ||
          query.page !== state.page || query.filters !== state.filters) return state;
      return action.type === actions.GET_LIST_SUCCESS ? {
        ...state, list: action.payload.messages, total: action.payload.total,
        loading: false, listLoaded: true, listError: null,
      } : {
        ...state, loading: false, listLoaded: false, listError: action.error,
      };
    }
    case actions.CREATE_SUCCESS:
    case actions.UPDATE_SUCCESS:
    case actions.DELETE_SUCCESS: {
      const data = action.requestPayload && action.requestPayload.data;
      if (!state.listContext || !data || data.providerId !== state.listContext.providerId ||
          data.userId !== state.listContext.userId) return state;
      const nextState = crud(state, action);
      return {
        ...nextState,
        page: action.type === actions.CREATE_SUCCESS && !data.ParentMessageId ? 1 : state.page,
      };
    }
    case actions.SET_FILTERS:
      return {
        ...state,
        page: 1, total: 0, listLoaded: false, listError: null,
        loading: !!state.listContext,
        filters: {
          ...action.payload,
          includePrivate: "true",
        },
      };
    case actions.TOGGLE_FILTER_MODAL:
      state = {
        ...state,
        filterModalActive: !state.filterModalActive,
      };
      return state;
    case actions.GET_FULL_LIST_REQUEST:
      state = {
        ...state,
        allNotes: {
          ...state.allNotes,
          loading: true,
          loaded: false,
        },
      };
      return state;
    case actions.GET_FULL_LIST_SUCCESS:
      return {
        ...state,
        allNotes: {
          ...state.allNotes,
          data: action.payload,
          loading: false,
          loaded: true,
          error: false,
        },
      };
    case actions.GET_FULL_LIST_ERROR:
      return {
        ...state,
        allNotes: {
          ...state.allNotes,
          loading: false,
          error: action.error,
        },
      };
    case actions.GET_ALERTS_LIST_REQUEST:
      state = {
        ...state,
        alerts: {
          ...state.alerts,
          loading: true,
          loaded: false,
        },
      };
      return state;
    case actions.GET_ALERTS_LIST_SUCCESS:
      return {
        ...state,
        alerts: {
          ...state.alerts,
          data: action.payload,
          loading: false,
          loaded: true,
          error: false,
        },
      };
    case actions.GET_ALERTS_LIST_ERROR:
      return {
        ...state,
        alerts: {
          ...state.alerts,
          loading: false,
          error: action.error,
        },
      };
    case actions.TOGGLE_REPLY_MODAL:
      state = {
        ...state,
        replyModalActive: !state.replyModalActive,
      };
      return state;
    case actions.TOGGLE_REPLIES:
      repliesActive = { ...state.repliesActive };
      repliesActive[action.payload] = !repliesActive[action.payload];
      state = {
        ...state,
        repliesActive: repliesActive,
      };
      return state;

    case actions.COMMUNICATION_MESSAGES_DOWNLOAD_CSV_REQUEST:
      return reduceDataRequest(state, "downloadCSV");
    case actions.COMMUNICATION_MESSAGES_DOWNLOAD_CSV_SUCCESS:
      return reduceDataSuccess(state, "downloadCSV", action.payload);
    case actions.COMMUNICATION_MESSAGES_DOWNLOAD_CSV_ERROR:
      return reduceDataError(state, "downloadCSV", action.error);

    default:
      return crud(state, action);
  }
};

export default reducers;
